import { render, staticRenderFns } from "./Magic.vue?vue&type=template&id=ff35651c&"
import script from "./Magic.vue?vue&type=script&lang=js&"
export * from "./Magic.vue?vue&type=script&lang=js&"
import style0 from "./Magic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports